// extracted by mini-css-extract-plugin
export default {"totalPriceBox":"styles_totalPriceBox__TkRNp","label":"styles_label__qmgJj","price":"styles_price__by4Ga","buttonBox":"styles_buttonBox__5dYGP"};